import { DaysOfWeek } from 'store/resource/types';

export const DAYS_ORDER = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
] as Array<DaysOfWeek>;
